export const en = {
  auth: {
    googleButton: {
      text: 'Continue with Google',
      errors: {
        login_failed: 'Unable to log in',
      },
    },
    microsoftButton: {
      text: 'Continue with Microsoft',
      errors: {
        login_failed: 'Unable to log in with Microsoft',
      },
    },
    confirmEmailForm: {
      email: {
        placeholder: 'eg. john@example.com',
        label: 'Email',
      },
      button: 'Resend email',
      success: 'Confirmation email sent',
      errors: {
        invalid_email: 'Please enter a valid email address',
      },
    },
    confirmEmailPage: {
      titles: {
        confirm: 'Confirm your email',
        unsuccessful: 'Confirmation unsuccessful',
        confirmed: 'Email confirmed!',
      },
      messages: {
        check_email: 'Please check your email for a confirmation link.',
        cant_find:
          "Can't find it? Enter your email below to have a new link sent.",
        login_complete: 'Please login to complete your registration.',
      },
      links: {
        return_login: 'Return to login',
      },
    },
    confirmEmailSuccessPage: {
      title: 'Success!',
      message: 'Please check your email for a new confirmation link.',
      links: {
        return_login: 'Return to log in',
      },
    },
    forgotPasswordPage: {
      title: 'Forgot password?',
      remember_password: 'Remember your password?',
      login_link: 'Log in.',
      form: {
        success_message: 'Password reset email sent',
        error_message: 'Unable to send password reset email',
      },
    },
    forgotPasswordSuccessPage: {
      title: 'Success!',
      message: 'Please check your email for a password reset link.',
      links: {
        return_login: 'Return to log in.',
      },
    },
    loginPage: {
      title: 'Log in',
      no_account: "Don't have an account?",
      signup_link: 'Sign up.',
      email_link: 'Log in with email',
      nonprofit_login_link: 'Visit Nonprofit Login Portal',
    },
    loginWithEmailPage: {
      title: 'Log in',
      forgot_password: 'Forgot password?',
      no_account: "Don't have an account?",
      signup_link: 'Sign up.',
      nonprofit_login_link: 'Visit Nonprofit Login Portal',
      errors: {
        login_failed: 'Unable to log in. Please check your credentials.',
      },
    },
    logoutButton: {
      text: 'Log Out',
      errors: {
        microsoft_logout_failed: 'Unable to log out from Microsoft account',
      },
    },
    resetPasswordPage: {
      title: 'Reset Password',
      remember_password: 'Remember your password?',
      login_link: 'Log in.',
      form: {
        success_message: 'Password successfully reset',
        error_message: 'Unable to reset password',
      },
    },
    resetPasswordSuccessPage: {
      title: 'Success!',
      message:
        'Your password has successfully been reset! Please return to the login screen to login',
      links: {
        return_login: 'Return to log in',
      },
    },
    signupPage: {
      title: 'Sign up',
      has_account: 'Already have an account?',
      login_link: 'Log in.',
      email_link: 'Sign up with email',
      nonprofit_signup_link: 'Visit Nonprofit Sign Up Portal',
    },
    signupWithEmailPage: {
      title: 'Sign up',
      has_account: 'Already have an account?',
      login_link: 'Log in.',
      terms: {
        agree_text: 'I agree to the',
        terms_link: 'Terms of Use',
        and: 'and',
        privacy_link: 'Privacy Policy',
      },
      errors: {
        company_not_exist: 'Company does not exist',
      },
    },
    forgotPasswordForm: {
      email: {
        placeholder: 'eg. john@example.com',
        label: 'Email',
      },
      button: 'Send reset password link',
      validation: {
        email_required: 'Please enter your email address',
        email_invalid: 'Please enter a valid email address',
      },
    },
    signupForm: {
      fields: {
        email: {
          label: 'Email',
          placeholder: 'eg. john@example.com',
        },
        password: {
          label: 'Password',
          placeholder: '•••••••',
        },
        confirmPassword: {
          label: 'Confirm Password',
          placeholder: '•••••••',
        },
      },
      validation: {
        terms_required:
          'You must agree to the terms of use and privacy policy.',
        passwords_match: 'Passwords must match.',
        email_required: 'Please enter your email address',
        email_invalid: 'Please enter a valid email address',
      },
      button: 'Sign up',
    },
    loginForm: {
      fields: {
        email: {
          label: 'Email',
          placeholder: 'eg. john@example.com'
        },
        password: {
          label: 'Password',
          placeholder: '•••••••'
        }
      },
      validation: {
        email_required: 'Please enter your email address',
        email_invalid: 'Please enter a valid email address',
        password_required: 'Please enter your password'
      },
      button: 'Log in',
      errors: {
        email_not_confirmed: 'Please confirm your email to continue',
        login_failed: 'Invalid email or password'
      }
    },
    nonprofitLoginPage: {
      title: 'Nonprofit Login',
      no_account: "Don't have a nonprofit account?",
      signup_link: 'Create one',
      company_login_link: 'Visit Company Login Portal',
    },
    nonprofitSignupPage: {
      title: 'Create Nonprofit Account',
      fields: {
        nonprofit: 'Your Nonprofit',
        email: 'Email Address',
        password: 'Password',
        confirmPassword: 'Confirm Password',
      },
      cant_find_nonprofit: "Can't find your nonprofit?",
      create_new_portal_link: 'Create a new one here',
      next_button: 'Continue',
      button: 'Create Account',
      has_account: 'Already have an account?',
      login_link: 'Log in',
    },
    nonprofitCreatePage: {
      title: 'Add your Nonprofit',
      fields: {
        name: 'Nonprofit Name',
        address: 'Nonprofit Address',
        logo: 'Nonprofit Logo',
        website: 'Website',
      },
      button: 'Create Nonprofit',
    }
  },
}
